export interface LanguageModel {
  value: string;
  country: string;
  description: string;
  img: string;
}